import React from 'react';
import { Modal, Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';

interface DeleteConfirmModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  mode: 'delete' | 'deactivate' | 'activate';
}

const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({ opened, onClose, onConfirm, mode }) => {
  const { t } = useTranslation();

  const title = (() => {
    switch (mode) {
      case 'delete':
        return t('adminConsole.employees.confirmDelete');
      case 'deactivate':
        return t('adminConsole.employees.confirmDeactivate');
      case 'activate':
        return t('adminConsole.employees.confirmActivate');
      default:
        return t('adminConsole.employees.confirmDelete');
    }
  })();

  const message = (() => {
    switch (mode) {
      case 'delete':
        return t('adminConsole.employees.confirmDeleteMessage');
      case 'deactivate':
        return t('adminConsole.employees.confirmDeactivateMessage');
      case 'activate':
        return t('adminConsole.employees.confirmActivateMessage');
      default:
        return t('adminConsole.employees.confirmDeleteMessage');
    }
  })();

  const confirmButtonText = (() => {
    switch (mode) {
      case 'delete':
        return t('common.delete');
      case 'deactivate':
        return t('adminConsole.employees.deactivate');
      case 'activate':
        return t('adminConsole.employees.activate');
      default:
        return t('common.delete');
    }
  })();

  const confirmButtonColor = mode === 'activate' ? 'green' : 'red';

  return (
    <Modal opened={opened} onClose={onClose} title={title} centered>
      <div>
        <p>{message}</p>
        <div className="flex justify-end mt-4">
          <Button variant="outline" onClick={onClose} className="mr-2">
            {t('common.cancel')}
          </Button>
          <Button color={confirmButtonColor} onClick={onConfirm}>
            {confirmButtonText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConfirmModal;
